import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useSnackbarStore } from '../../../shared/stores/snackbarStore';

export const orgAutoSubmitKeys = {
  all: ['organisation', 'auto-submit'] as const,
  overview: () => [...orgAutoSubmitKeys.all, 'overview'] as const,
  settings: () => [...orgAutoSubmitKeys.all, 'settings'] as const,
};

export function useOrgAutoSubmitOverview() {
  return useQuery({
    queryKey: orgAutoSubmitKeys.overview(),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v1/organisations/settings/auto-submit', {
          signal,
        })
      ),
  });
}

export function useSetOrgAutoSubmit() {
  const queryClient = useQueryClient();
  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  return useMutation({
    mutationFn: async (isEnabled: boolean) =>
      unwrap(
        await api.legacy.PUT('/api/v1/organisations/settings/auto-submit', {
          body: { isEnabled },
        })
      ),
    onSuccess: (_data, isEnabled) => {
      queryClient.invalidateQueries({
        queryKey: orgAutoSubmitKeys.overview(),
      });
      queryClient.invalidateQueries({
        queryKey: orgAutoSubmitKeys.settings(),
      });
      showSnackbar(
        isEnabled
          ? 'Auto-submit turned on — applies from each new pot'
          : 'Auto-submit turned off — applies from each new pot',
        'success'
      );
    },
  });
}
